import BaseProxy from './Proxy';

export default class CustomerSearchProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/customerSearch', parameters);
  }
}
